import { styled } from '@mui/material';

export const ContentW = styled('div')`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
`;

export const FormW = styled('div')`
  width: 672px;
  position: relative;
  border-radius: 15px;
  padding: 0px 0px 40px 0px;

  &:before {
    backdrop-filrgba(3, 3, 3, 0.7)
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    border-radius: 15px;
  }

  @media (max-width: 1023px) {
    width: 100%;
    padding: 16px 8px;
  }
`;
